import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { LandingPage } from './pages/LandingPage';
// Preload critical LCP image IMMEDIATELY
const preloadLink = document.createElement('link');
preloadLink.rel = 'preload';
preloadLink.as = 'image';
preloadLink.href = 'https://cdn.magicpatterns.com/uploads/fMZ5Fq5SNbxYwzfww2mdPS/Diseno_sin_titulo_(1).webp';
preloadLink.fetchPriority = 'high';
preloadLink.imageSrcset = 'https://cdn.magicpatterns.com/uploads/fMZ5Fq5SNbxYwzfww2mdPS/Diseno_sin_titulo_(1).webp 340w';
preloadLink.imageSizes = '(max-width: 768px) 260px, 340px';
document.head.insertBefore(preloadLink, document.head.firstChild);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-52" data-mp="2p1mpn7sdajjo">
    <LandingPage data-id="element-53" data-mp="2tzeq4q72vdzh" />
  </React.StrictMode>);